

















































// vendor
import { defineComponent, computed, ref } from "@vue/composition-api";
// project
import { copyToClipboard } from "@/utils/dom";

export default defineComponent({
	props:{
		studyId:{
			type:String,
			required:true,
		},
		enabled:{
			type:Boolean,
			default:false,
		}
	},
	setup(props){

		const urlBox = ref<HTMLInputElement>();

		const url = computed(() => {
			return `${window.location.origin}/p/s/${props.studyId}`;
		});

		const copy = () => {

			console.log(urlBox);
			if(!urlBox.value){ return; }
			urlBox.value.select();
			document.execCommand("copy");
		};

		return {
			url,
			urlBox,
			copy,
		};
	}
});

